import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLinktreeComponent } from './simple-icons-linktree.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLinktreeComponent ],
    exports:      [ SimpleIconsLinktreeComponent ],
    bootstrap:    []
})
export class SimpleIconsLinktreeModule {}
